var _path, _mask;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFileActive = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#85C7F6",
    fillRule: "evenodd",
    d: "M11.667 3.315l3.118 3.352h-2.523c-.329 0-.595-.318-.595-.709V3.315zm4.784 2.792L12.747 1.94c-.158-.174-.382-.273-.617-.273H5.463c-1.175 0-2.13.935-2.13 2.083v12.5c0 1.148.955 2.083 2.13 2.083h9.074c1.175 0 2.13-.935 2.13-2.083V6.667c0-.208-.077-.407-.216-.56z",
    clipRule: "evenodd"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "prefix__a",
    width: 14,
    height: 18,
    x: 3,
    y: 1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.667 3.315l3.118 3.352h-2.523c-.329 0-.595-.318-.595-.709V3.315zm4.784 2.792L12.747 1.94c-.158-.174-.382-.273-.617-.273H5.463c-1.175 0-2.13.935-2.13 2.083v12.5c0 1.148.955 2.083 2.13 2.083h9.074c1.175 0 2.13-.935 2.13-2.083V6.667c0-.208-.077-.407-.216-.56z",
    clipRule: "evenodd"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFileActive, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/file_active.bab553f6.svg";
export { ForwardRef as ReactComponent };